import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MUIRadioGroup, FormHelperText } from "@mui/material";
import React from "react";

const RadioGroup = (props) => {

  const {
    controleId,
    comp,
    stateData: data,
    stateErrors: errors,
    isDisabled,
    handeOnChange,
  } = props;

  return (
    // <div
    //   className={`form-group ${comp.isRequired && "required"}`}
    //   role="radiogroup"
    //   aria-labelledby={controleId + "_group_label"}
    //   id={controleId + "_rg"}
    // >
    //   <label
    //     className="form-control-label mr-2"
    //     id={controleId + "_group_label"}
    //   >
    //     {comp.label}
    //   </label>
    //   {comp.radioValues.map((item, key) => (
    //     <div className="custom-control custom-radio mb-2">
    //       <input
    //         tabIndex={key}
    //         name={controleId}
    //         className={comp.cssclass ? comp.cssclass + " custom-control-input": "custom-control-input"}
    //         id={controleId + key}
    //         type="radio"
    //         onChange={handeOnChange}
    //         value={item.value}
    //         defaultChecked={data[controleId] === item.value}
    //         disabled={isDisabled}
    //         aria-labelledby={controleId + key}
    //         aria-checked={data[controleId] === item.value}
    //       />
    //       <label
    //         className="custom-control-label mr-2 pt-1"
    //         htmlFor={controleId + key}
    //       >
    //         {item.name}
    //       </label>
    //     </div>
    //   ))}
    //   {errors[controleId] && (
    //     <div className="alert alert-danger">{errors[controleId]}</div>
    //   )}
    // </div>
    <FormControl fullWidth variant="outlined" 
    error={errors[controleId] ? true : false}
     required={comp?.isRequired}
     disabled={isDisabled}
     >
      <FormLabel
        sx={{
          fontSize: "14px",
          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
          fontWeight: 400,
          color: "#000000",
          "&.Mui-disabled": {
            color: "#333333",
            opacity: 1,
          },
        }}
      >{comp.label}</FormLabel>
      <MUIRadioGroup
        row={true}
        value={!data[controleId] ? "" : data[controleId]}
        name={controleId}
        onChange={handeOnChange}
        sx={{
          "& .MuiFormControlLabel-label": {
            fontSize: "14px",
            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
            fontWeight: 400,
            color: "#000000",
          },
          "& .Mui-disabled .MuiFormControlLabel-label": {
            color: "#555555",
            opacity: 0.9,
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#555555",
            color: "#555555",
            opacity: 0.9,
          },
          "& .MuiInputLabel-root.Mui-disabled": {
            color: "#333333",
            opacity: 1,
          },
        }}
      >
        {comp.radioValues.map((item, key) => {
          return <FormControlLabel key={key} value={item.value} control={<Radio />} label={item.name} />
        })}
      </MUIRadioGroup>
      {errors[controleId] && <FormHelperText>{errors[controleId]}</FormHelperText>}
    </FormControl>
  );
}

export default RadioGroup;